( function () {
	'use strict';

	/* eslint-disable max-params */
	function ObsManagePrivModalController ( $scope, logger, $modalInstance, createObsService, apiService, TOOLTIP_MESSAGES, confirmInReviewObj, $filter, _, filterFilter, Session, q, $modal, observationService, $route ) {
		var self = this;

		var credentials = Session.getCredentials();

		self.selections    = [ ];
		self.users         = [ ];
		self.observationId = confirmInReviewObj.observationId;
		self.obs           = confirmInReviewObj.passedObs;

		self.viewPrivileges = {
			'state'     : [],
			'origState' : [],
			'toUpdate'  : [],
			'toRemove'  : []
		};

		self.itemsPerPage  = 10;
		self.currentPage   = 1;
		self.maxSize       = 10;

		self.legendTooltip = TOOLTIP_MESSAGES.manageObsViewLegend;

		self.allow = [ null, true, false ];

		self.privileges = {
			'true'  : 1,
			'false' : 2
		};

		self.origData = [ ];

		self.searchText = { };

		self.filteredItems = [ ];

		function getSign ( type, method ) {
			return ( ( self.obs.digitalSignature || {} )[ type ] || [] )[ method ]( function ( signee ) {
				return signee.isValid;
			} );
		}

		function getSchools () {
			self.fetchTimeout   = true;
			self.schoolsLoading = true;

			q.all( [
				createObsService.getInReviewLocations(),
				createObsService.getObsViewRights( self.observationId )
			] )
			.then( function ( results ) {
				var districts = results[ 0 ].data;
				var viewPriv  = results[ 1 ].data.data;

				var schools = [ ];

				self.viewPrivileges.origState = viewPriv;
				self.viewPrivileges.state     = angular.copy( viewPriv );
				self.getPriv( self.observee );

				// look into all districts
				( districts || [ ] ).map( function ( district ) {
					schools = schools.concat( district.Schools || [] );
				} );

				if ( schools.length ) {
					self.schools = schools;
					return self.schools;
				}

				self.fetchTimeout = false;
				return self.fetchTimeout;
			}, function () {
				self.fetchTimeout = false;
				return self.fetchTimeout;
			} )
			.finally( function () {
				self.schoolsLoading = false;
			} );
		}

		function getPriv ( user ) {
			var id = String( user.PersonnelId );

			user.privilege = self.privileges[ self.viewPrivileges.state.indexOf( id ) > -1 || 0 ] || 0;
			return user;
		}

		function fetchPriv () {
			var pageStart  = self.itemsPerPage * ( self.currentPage - 1 );
			var pageSize   = self.itemsPerPage;
			var collection = $filter( 'paging' )( self.users, pageStart, pageSize );

			collection = $filter( 'limitTo' )( collection, self.itemsPerPage );

			( collection || [] ).map( getPriv );
		}

		function updatePriv ( user, isAllow ) {
			var data = {
				'userId'        : user.PersonnelId,
				'observationId' : self.observationId
			};

			var body = {
				'allow' : isAllow
			};

			apiService
			.obsViewPrivilege
			.update( data, body )
			.$promise
			.catch( function () {
				logger.notifyError( 'Observation', 'Unable to update  view privilege' );
			} );
		}

		function deletePriv ( user ) {
			var data = {
				'userId'        : user.PersonnelId,
				'observationId' : self.observationId
			};

			apiService
			.obsViewPrivilege
			.delete( data )
			.$promise
			.catch( function () {
				logger.notifyError( 'Observation', 'Unable to update  view privilege' );
			} );
		}

		function updateObs () {
			function success () {
				logger.info( 'Successfully assigned signature PD for reviewers.' );
				$route.reload();
			}

			function fail () {
				logger.notifyError( 'Unable to attach pd for reviewers.' );
			}

			var params = {
				'userId'      : Session.getCredentials().userId,
				'observation' : 'observation'
			};

			var originalObs = angular.copy( self.obs );
			var rubric      = angular.extend( [], originalObs.template.rubric );
			var groups      = angular.extend( [], originalObs.template.groups );
			var pd          = angular.extend( [], originalObs.prescribedResources );

			originalObs.observee = _.pick( originalObs.observee, 'id' );
			originalObs.observer = _.pick( originalObs.observer, 'id' );
			originalObs.location = _.pick( originalObs.location, 'observeeClientId' );

			rubric.forEach( observationService.maskUtil().rubricMask );
			groups.forEach( observationService.maskUtil().groupMask );
			pd.forEach( observationService.maskUtil().prescribedResourcesMask );
			groups.forEach( observationService.maskUtil().openEndedMask );

			delete originalObs.onObsList;
			delete originalObs.score;
			delete originalObs.fbEnabled;

			apiService.observation.update( params, observationService.normalize( originalObs, {}, true ), success, fail );
		}

		function modifyReviewerDigitalSigPD () {
			function checkMasterPD () {
				var usersWithViewRights = angular.copy( self.viewPrivileges.state );

				function removeExistingNonReviewer ( id ) {
					id = Number( id );
					return id !== Number( self.obs.observer.id ) && id !== Number( self.obs.observee.id );
				}

				function removePDOfUsersWithoutRights ( pd ) {
					var pdOwner = String( pd.pdOwner );
					var index   = usersWithViewRights.indexOf( pdOwner );

					usersWithViewRights.splice( index, Number( index > -1 ) );

					return self.viewPrivileges.toRemove.indexOf( pdOwner ) < 0;
				}

				function generateReviewerPD ( id ) {
					return {
						'id'           : self.obs.id,
						'resourceId'   : self.obs.id,
						'pdOwner'      : Number( id ),
						'type'         : 4,
						'assignedDate' : new Date()
					};
				}

				self.obs.masterPrescribedResources = self.obs.masterPrescribedResources
					.filter( removePDOfUsersWithoutRights )
					.concat( usersWithViewRights.filter( removeExistingNonReviewer ).map( generateReviewerPD ) );

				[ confirmInReviewObj.location !== 'obs-edit' ].filter( Boolean ).forEach( updateObs );
			}

			var signature      = angular.extend( { 'observer' : [] }, self.obs.digitalSignature );
			var attachDigSigPD = [ self.signatureFlag, signature.observer.length ].some( Boolean );

			[ attachDigSigPD && self.obs.partialSubmission ].filter( Boolean ).map( checkMasterPD );
		}

		function save () {
			self.updatingBtn = true;

			self.viewPrivileges.toUpdate.forEach( function ( id ) {
				updatePriv( { 'PersonnelId' : id }, true );
			} );

			self.viewPrivileges.toRemove.forEach( function ( id ) {
				deletePriv( { 'PersonnelId' : id } );
			} );

			modifyReviewerDigitalSigPD();
			// passed false for in review flag
			$modalInstance.close( false );
		}

		function signatureModal () {
			$modal.open( {
				'templateUrl'  : '/templates/observations/signature-modal/signature-modal.html',
				'controller'   : 'signatureModalCtrl',
				'controllerAs' : 'sig',
				'windowClass'  : '',
				'resolve'      : {
					'obs' : function () {
						return self.obs;
					},

					'submitFn' : function () {
						return save;
					},

					'submitStatus' : function () {
						return 'inreview';
					},
					'parentController' : function () {
						return self;
					}
				}
			} );
		}

		function openModal ( forReviewOnly ) {
			( ( forReviewOnly || confirmInReviewObj.checkValid( self.obs ) ) && signatureModal || angular.noop )();
		}

		function watch () {
			$scope.$watch( function () {
				return self.selections;
			}, function ( val ) {
				if ( val.length ) {
					var collection = _.sortBy( angular.copy( val[ 0 ].data.users ), 'FirstName' );

					collection = collection.filter( function ( data ) {
						return data.PersonnelId !== credentials.PersonnelId;
					} ).filter( function ( data ) {
						return data.PersonnelId !== self.observee.id;
					} );

					self.users = _.map( collection, function ( obj ) {
						obj.FullName = obj.FirstName + ' ' + obj.LastName;
						getPriv( obj );
						return obj;
					} );

					self.origData = angular.copy( self.users );

					self.currentPage = 1;
				}
			}, true );

			$scope.$watch( function () {
				return self.searchText;
			}, function ( val ) {
				if ( !_.isEmpty( val ) ) {
					self.filteredItems = filterFilter( self.origData, { 'FullName' : self.searchText.FullName } );

					if ( self.searchText.FullName.trim() !== '' && !self.filteredItems.length ) {
						return;
					}

					self.users = self.origData;

					if ( self.filteredItems.length ) {
						self.users = self.filteredItems;
					}

					self.currentPage = 1;

					self.fetchPriv();
				}
			}, true );
		}

		function checkIfExist ( arr, value ) {
			return arr.indexOf( value ) > -1;
		}

		function removeFrom ( arr, value ) {
			var index = arr.indexOf( value );

			if ( index > -1 ) {
				arr.splice( index, 1 );
			}
		}

		function addFrom ( arr, value ) {
			var index = arr.indexOf( value );

			if ( index === -1 ) {
				arr.push( value );
			}
		}

		function updateStates ( id, property, ifExistCallback, ifNotExistCallback ) {
			var arr = self.viewPrivileges[ property ];

			( checkIfExist( arr, id ) && ifExistCallback || ifNotExistCallback )( arr, id );
		}

		function removingPriv ( id ) {
			// remove id from state reference
			updateStates( id, 'state', removeFrom, angular.noop );
			// remove id from to update reference
			updateStates( id, 'toUpdate', removeFrom, angular.noop );

			self.viewPrivileges.toRemove.push( id );
		}

		function updatingPriv ( id ) {
			// update array for reference
			updateStates( id, 'state', angular.noop, addFrom );
			// remove id from remove reference
			updateStates( id, 'toRemove', removeFrom, angular.noop );

			if ( !checkIfExist( self.viewPrivileges.origState, id ) ) {
				self.viewPrivileges.toUpdate.push( id );
			}
		}

		function toggle ( model ) {
			var id = String( model.PersonnelId );

			model.privilege = model.privilege + 1;

			if ( model.privilege > 1 ) {
				model.privilege = 0;

				removingPriv( id );
			}

			if ( model.privilege > 0 ) {
				updatingPriv( id );
			}
		}

		self.save           = save;
		self.toggle         = toggle;
		self.getSchools     = getSchools;
		self.watch          = watch;
		self.fetchPriv      = fetchPriv;
		self.getPriv        = getPriv;
		self.cancel         = $modalInstance.dismiss;
		self.signatureModal = openModal;
		self.getSign        = getSign;

		function activate () {
			logger.info( 'Manage View Privilege Modal' );
			self.isInReview           = confirmInReviewObj.passedObs.partialSubmission;
			self.onObsList            = confirmInReviewObj.passedObs.onObsList;
			self.observee             = angular.copy( confirmInReviewObj.passedObs.observee );
			self.observee.PersonnelId = self.observee.id;

			self.getSchools();
			self.watch();
		}

		activate();
	}

	angular
		.module( 'app.observations' )
		.controller( 'ObsManagePrivModalController', ObsManagePrivModalController );

	ObsManagePrivModalController.$inject = [ '$scope', 'logger', '$modalInstance', 'createObsService', 'apiService', 'TOOLTIP_MESSAGES', 'confirmInReviewObj', '$filter', '_', 'filterFilter', 'Session', '$q', '$modal', 'observationService', '$route' ];
} )();
